(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.KMPrimaryRide = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var endpoint = '/api/vehicle/switchPrimaryVehicle';

  function isPrimaryRide(ride) {
    if (!ride || typeof ride !== 'object') return false;
    return String(ride.primaryVehicle).trim() === '1';
  }

  function toRequiredInteger(value, fieldName, allowZero) {
    var text = String(value === undefined || value === null ? '' : value).trim();
    var number = Number(text);
    var minimum = allowZero ? 0 : 1;
    if (!text || !Number.isInteger(number) || number < minimum) {
      throw new Error('Invalid ' + fieldName);
    }
    return number;
  }

  function joinUrl(baseUrl, path) {
    var base = String(baseUrl || '').replace(/\/+$/, '');
    return base ? base + path : path;
  }

  function buildSwitchRequest(rideId, userId, baseUrl) {
    var payload = {
      id: toRequiredInteger(rideId, 'ride id', false),
      shop: 'kemimoto_us',
      userId: toRequiredInteger(userId, 'user id', true)
    };

    return {
      url: joinUrl(baseUrl, endpoint),
      options: {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }
    };
  }

  function preservePrimaryVehicle(existingRide, updatedRide) {
    var existing = existingRide && typeof existingRide === 'object' ? existingRide : {};
    var updated = updatedRide && typeof updatedRide === 'object' ? updatedRide : {};
    var merged = Object.assign({}, existing, updated);
    merged.primaryVehicle = isPrimaryRide(existing) ? 1 : 0;
    return merged;
  }

  function rideMatches(left, right) {
    if (!left || !right) return false;
    var leftId = String(left.id || '').trim();
    var rightId = String(right.id || '').trim();
    if (leftId && rightId && leftId === rightId) return true;
    return ['year', 'make', 'model'].every(function (key) {
      return String(left[key] || '').trim().toLowerCase() === String(right[key] || '').trim().toLowerCase();
    });
  }

  function mergeGuestGarageRide(cachedRides, stateRides, newRide) {
    var merged = [];
    (cachedRides || []).concat(stateRides || []).forEach(function (ride) {
      if (!ride || typeof ride !== 'object') return;
      var index = merged.findIndex(function (existing) { return rideMatches(existing, ride); });
      if (index === -1) {
        merged.push(Object.assign({}, ride));
        return;
      }
      merged[index] = preservePrimaryVehicle(merged[index], ride);
    });

    if (!newRide || typeof newRide !== 'object') return merged;
    var existingIndex = merged.findIndex(function (ride) { return rideMatches(ride, newRide); });
    var savedRide = existingIndex === -1
      ? Object.assign({}, newRide)
      : preservePrimaryVehicle(merged[existingIndex], newRide);
    if (String(newRide.emailBinding || '').toLowerCase() === 'unbound') delete savedRide.email;
    savedRide.isCurrent = true;
    merged = merged.filter(function (_, index) { return index !== existingIndex; }).map(function (ride) {
      return Object.assign({}, ride, { isCurrent: false });
    });
    return [savedRide].concat(merged);
  }

  function switchPrimaryRide(options) {
    var opts = options || {};
    var api = opts.api;
    var refreshRides = opts.refreshRides;
    if (!api || typeof api.post !== 'function') return Promise.reject(new Error('Missing API client'));
    if (typeof refreshRides !== 'function') return Promise.reject(new Error('Missing vehicle refresh'));

    var request;
    try {
      request = buildSwitchRequest(opts.rideId, opts.userId);
    } catch (error) {
      return Promise.reject(error);
    }

    return api.post(request.url, JSON.parse(request.options.body), false, {}, { credentials: 'include' })
      .then(function (payload) {
            if (!payload || Number(payload.code) !== 200) {
              throw new Error(payload && payload.msg ? String(payload.msg) : 'Unable to change primary ride.');
            }
            return refreshRides();
      });
  }

  return {
    isPrimaryRide: isPrimaryRide,
    buildSwitchRequest: buildSwitchRequest,
    preservePrimaryVehicle: preservePrimaryVehicle,
    mergeGuestGarageRide: mergeGuestGarageRide,
    switchPrimaryRide: switchPrimaryRide
  };
});
